import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import "@fontsource/roboto/300.css";
import NamesGrid from "./NamesGrid";
import DesignDetailsGrid from "./DesignDetailsGrid";
import HeadingInputsGrid from "./HeadingInputsGrid";
import GeometricParamsGrid from "./GeometricParamsGrid";
import MaterialsGrid from "./MaterialsGrid";

const FIXED_PAGE_WIDTH = 1600; // same as 80% of 1920px
const FIXED_COLUMNS = 11;

const fixedGridSx = {
  /**
   * Force all MUI Grid items inside this page to keep desktop sizing.
   * This is local only because it is inside this DesignTab wrapper.
   */

  "& .MuiGrid-grid-xl-1, & .MuiGrid-grid-lg-1": {
    flexBasis: `${(1 / FIXED_COLUMNS) * 100}% !important`,
    maxWidth: `${(1 / FIXED_COLUMNS) * 100}% !important`,
  },
  "& .MuiGrid-grid-xl-2, & .MuiGrid-grid-lg-2": {
    flexBasis: `${(2 / FIXED_COLUMNS) * 100}% !important`,
    maxWidth: `${(2 / FIXED_COLUMNS) * 100}% !important`,
  },
  "& .MuiGrid-grid-xl-3, & .MuiGrid-grid-lg-3": {
    flexBasis: `${(3 / FIXED_COLUMNS) * 100}% !important`,
    maxWidth: `${(3 / FIXED_COLUMNS) * 100}% !important`,
  },
  "& .MuiGrid-grid-xl-4, & .MuiGrid-grid-lg-4": {
    flexBasis: `${(4 / FIXED_COLUMNS) * 100}% !important`,
    maxWidth: `${(4 / FIXED_COLUMNS) * 100}% !important`,
  },
  "& .MuiGrid-grid-xl-5, & .MuiGrid-grid-lg-5": {
    flexBasis: `${(5 / FIXED_COLUMNS) * 100}% !important`,
    maxWidth: `${(5 / FIXED_COLUMNS) * 100}% !important`,
  },
  "& .MuiGrid-grid-xl-6, & .MuiGrid-grid-lg-6": {
    flexBasis: `${(6 / FIXED_COLUMNS) * 100}% !important`,
    maxWidth: `${(6 / FIXED_COLUMNS) * 100}% !important`,
  },
  "& .MuiGrid-grid-xl-7, & .MuiGrid-grid-lg-7": {
    flexBasis: `${(7 / FIXED_COLUMNS) * 100}% !important`,
    maxWidth: `${(7 / FIXED_COLUMNS) * 100}% !important`,
  },
  "& .MuiGrid-grid-xl-8, & .MuiGrid-grid-lg-8": {
    flexBasis: `${(8 / FIXED_COLUMNS) * 100}% !important`,
    maxWidth: `${(8 / FIXED_COLUMNS) * 100}% !important`,
  },
  "& .MuiGrid-grid-xl-9, & .MuiGrid-grid-lg-9": {
    flexBasis: `${(9 / FIXED_COLUMNS) * 100}% !important`,
    maxWidth: `${(9 / FIXED_COLUMNS) * 100}% !important`,
  },
  "& .MuiGrid-grid-xl-10, & .MuiGrid-grid-lg-10": {
    flexBasis: `${(10 / FIXED_COLUMNS) * 100}% !important`,
    maxWidth: `${(10 / FIXED_COLUMNS) * 100}% !important`,
  },
  "& .MuiGrid-grid-xl-11, & .MuiGrid-grid-lg-11": {
    flexBasis: "100% !important",
    maxWidth: "100% !important",
  },
};

const DesignTab = () => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        overflow: "auto",
        display: "block",
        backgroundColor: "transparent",
        ...fixedGridSx,
      }}
    >
      <Box
        sx={{
          width: `${FIXED_PAGE_WIDTH}px`,
          minWidth: `${FIXED_PAGE_WIDTH}px`,
          maxWidth: `${FIXED_PAGE_WIDTH}px`,
          flexShrink: 0,
          backgroundColor: "transparent",
        }}
      >
        <Grid
          container
          marginTop={0.2}
          spacing={1}
          columns={FIXED_COLUMNS}
          direction="row"
          rowSpacing={0.7}
          alignItems="flex-start"
          sx={{
            width: `${FIXED_PAGE_WIDTH}px`,
            minWidth: `${FIXED_PAGE_WIDTH}px`,
            maxWidth: `${FIXED_PAGE_WIDTH}px`,
            flexWrap: "wrap",
          }}
        >
          <NamesGrid />

          <DesignDetailsGrid />

          {/* empty grid */}
          <Grid item xs={5} lg={5} xl={5}></Grid>

          {/* Heading Inputs and Design Inputs Grid */}
          <HeadingInputsGrid />

          {/* Geometric Parameters Input Grid */}
          <GeometricParamsGrid />

          {/* empty grid */}
          <Grid item xs={5} lg={5} xl={5}></Grid>

          {/* Last Excel box */}
          <MaterialsGrid />
        </Grid>
      </Box>
    </Box>
  );
};

export default DesignTab;
